import { Table } from '@tanstack/react-table'
import { Input } from '@/components/ui/input'
import { DataTableViewOptions } from '@/components/Table/data-table-view-options'
import { DataTableFacetedFilter } from '@/components/Table/data-table-faceted-filter'
import { Filter } from '@/components/Table/filters'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface DataTableToolbarProps<TData> {
   readonly table: Table<TData>
   readonly className?: string
}

export function DataTableToolbar<TData>({ table, className }: DataTableToolbarProps<TData>) {
   const isFiltered = table.getState().columnFilters.length > 0

   return (
      <div className={cn('flex w-full items-center justify-between space-x-2 overflow-auto p-1', className)}>
         <div className="flex flex-1 items-center space-x-2">
            <Input
               placeholder="Find Conversations by Title..."
               value={(table.getColumn('title')?.getFilterValue() as string) ?? ''}
               onChange={(event) => table.getColumn('title')?.setFilterValue(event.target.value)}
               className="h-8 w-40 lg:w-64"
            />
            {table.getColumn('date') && (
               <DataTableFacetedFilter
                  column={table.getColumn('date')}
                  title="By Date"
                  options={Filter({ column: table.getColumn('date') })}
               />
            )}
            {isFiltered && (
               <Button aria-label="Reset filters" variant="ghost" size="sm" onClick={() => table.resetColumnFilters()}>
                  <X className="size-4" aria-hidden="true" />
                  Reset
               </Button>
            )}
         </div>
         <div className="flex items-center gap-2">
            <DataTableViewOptions table={table} ignoreColumn={1} />
         </div>
      </div>
   )
}
